"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionModule = void 0;
var _i18n = require("@ori/i18n");
var _constants = require("../../constants");
var _SubscriptionModuleContent = require("./SubscriptionModuleContent");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionModule = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
  namespace: _constants.translationsNamespace,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionModuleContent.SubscriptionModuleContent, {
    ...props
  })
});
exports.SubscriptionModule = SubscriptionModule;
//# sourceMappingURL=SubscriptionModule.js.map